@let minPrice = product()?.priceRange?.minVariantPrice;

@if (showLabel()) {
  <small class="me-1 type-body-xs">{{ 'product-card-vanaf-prijf-prefix' | fromDictionary }}</small>
}

@if (product()?.compareAtPriceRange?.minVariantPrice; as comparePrice) {
  @if (+comparePrice.amount > +(minPrice?.amount || 0)) {
    <div class="d-inline-flex flex-column">
      <del class="product-card__discount-before-price price--old type-body-xs">
        {{ comparePrice.amount | currency: comparePrice.currencyCode }}
      </del>
      <strong class="price--new">{{ minPrice?.amount | currency: minPrice?.currencyCode }}</strong>
    </div>
  } @else {
    <span>{{ minPrice?.amount | currency: minPrice?.currencyCode }}</span>
  }
} @else {
  <span>{{ minPrice?.amount | currency: minPrice?.currencyCode }}</span>
}
